import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { SeoService } from '../services/seo.service';

@Injectable({
	providedIn: 'root',
})
export class SeoResolver implements Resolve<any> {
	protected constructor(private seo: SeoService) {}

	// Handle the SEO Google indexing for category page
	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void {
		const URL = state.url.split('?')[0];
		const categoryId = route.params?.category;

		// Check if the current route is included in sitemap.xml.
		// The only category id we indexing for now is 15 and 17.
		if (categoryId !== '15' && categoryId !== '17') {
			this.seo.createCanonicalLinkElement(URL);
		}
	}
}
